import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo, useState } from 'react';
export function useAutoComplete(t0) {
  const $ = _c(27);
  const {
    data,
    getDisplayValue,
    getSearchValue,
    onSearchValueChange,
    onSelectedValueChange,
    searchValue,
    selectedValue
  } = t0;
  const [open, setOpen] = useState(false);
  let t1;
  let map;
  if ($[0] !== data || $[1] !== getSearchValue) {
    map = new Map();
    data.forEach(item => {
      const key = getSearchValue(item);
      map.set(key, item);
    });
    $[0] = data;
    $[1] = getSearchValue;
    $[2] = map;
  } else {
    map = $[2];
  }
  t1 = map;
  const searchValueToItemMap = t1;
  let t2;
  bb0: {
    if (selectedValue) {
      let t3;
      if ($[3] !== getDisplayValue || $[4] !== selectedValue) {
        t3 = getDisplayValue(selectedValue);
        $[3] = getDisplayValue;
        $[4] = selectedValue;
        $[5] = t3;
      } else {
        t3 = $[5];
      }
      t2 = t3;
      break bb0;
    }
    t2 = searchValue;
  }
  const displayValue = t2;
  let t3;
  if ($[6] !== onSearchValueChange || $[7] !== onSelectedValueChange) {
    t3 = () => {
      onSelectedValueChange(undefined);
      onSearchValueChange("");
    };
    $[6] = onSearchValueChange;
    $[7] = onSelectedValueChange;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const reset = t3;
  let t4;
  if ($[9] !== getDisplayValue || $[10] !== reset || $[11] !== searchValue || $[12] !== selectedValue) {
    t4 = e => {
      if (!e.relatedTarget?.hasAttribute("cmdk-list") && (selectedValue === null || getDisplayValue(selectedValue) !== searchValue)) {
        reset();
      }
      setOpen(false);
    };
    $[9] = getDisplayValue;
    $[10] = reset;
    $[11] = searchValue;
    $[12] = selectedValue;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const onInputBlur = t4;
  let t5;
  if ($[14] !== getDisplayValue || $[15] !== getSearchValue || $[16] !== onSearchValueChange || $[17] !== onSelectedValueChange || $[18] !== reset || $[19] !== searchValueToItemMap || $[20] !== selectedValue) {
    t5 = searchKey => {
      const selected = searchValueToItemMap.get(searchKey);
      if (selected) {
        if (selectedValue && getSearchValue(selectedValue) === searchKey) {
          reset();
        } else {
          onSelectedValueChange(selected);
          onSearchValueChange(getDisplayValue(selected));
        }
      }
      setOpen(false);
    };
    $[14] = getDisplayValue;
    $[15] = getSearchValue;
    $[16] = onSearchValueChange;
    $[17] = onSelectedValueChange;
    $[18] = reset;
    $[19] = searchValueToItemMap;
    $[20] = selectedValue;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  const onSelectItem = t5;
  let t6;
  if ($[22] !== displayValue || $[23] !== onInputBlur || $[24] !== onSelectItem || $[25] !== open) {
    t6 = {
      displayValue,
      onInputBlur,
      onSelectItem,
      open,
      setOpen
    };
    $[22] = displayValue;
    $[23] = onInputBlur;
    $[24] = onSelectItem;
    $[25] = open;
    $[26] = t6;
  } else {
    t6 = $[26];
  }
  return t6;
}